export function toKebabCase(value) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/[^a-z0-9\u00C0-\u00FF]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function removeAccents(string_) {
  return string_.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
}
